// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__O5sRT","topBottomGutter":"Layout_topBottomGutter___uRLr"};